export default import.meta.ROLLUP_FILE_URL_trIscySKlHy7Xjfgm3RkKQ